import { FoodHotDogIcon } from './FoodHotDogIcon';

/**
 * author: Michael Irigoyen
 * id 71DB0C17-56B2-4664-9AD2-BF6EDB375D59
 * name food-hot-dog
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-hot-dog.svg
 * tags
 * - Food / Drink 
 */
export const FoodWeinerIcon = FoodHotDogIcon;
export default FoodWeinerIcon